export default {
  navegacaoSubnivel: false,
}
